import { UserUtilities } from '@pwc/pwc-deals-web-common';
import { CommentThread, User } from './types';

export const scrollToLastComment = (): void => {
  const el = document.querySelector('.ck-sidebar-item:last-child');

  if (el) {
    (el as HTMLDivElement).scrollIntoView({ block: 'end' });
  }
};

export const getFeedItems = (
  queryText: string,
  users: User[],
  projectId: number,
  isEntitySharedWithClient: boolean
): User[] => {
  function isItemMatching(item: string) {
    // Make the search case-insensitive.
    const searchString = queryText.toLowerCase();
    // Include an item in the search results if the name or username includes the current user input.
    return item.toLowerCase().includes(searchString);
  }
  // When content is in client draft return all users
  // When content is in progress return PwC users
  const mentionList = isEntitySharedWithClient
    ? users
    : users.filter((user) => UserUtilities.isPractitioner(user, +projectId));

  const usersWithFormattedNames = mentionList.map((user) => ({
    ...user,
    userId: user.id,
    id: `@${user.firstName} ${user.lastName}`,
  }));

  const slicedUsers = usersWithFormattedNames
    .filter((user) => isItemMatching(user.id.toString()))
    .slice(0, 10);

  return slicedUsers;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const formatThread = (thread: CommentThread) => {
  const comments = (thread.comments || []).map((comment) => ({
    ...comment,
    authorId: (comment.authorId || '').toString(),
  }));

  return {
    ...thread,
    threadId: thread.id,
    comments,
  };
};

export const customItemRenderer = ({ userId, id, email }: User) => {
  const itemElement = document.createElement('button');
  itemElement.classList.add('ck', 'ck-button', 'ck-off', 'ck-button_with-text');

  const usernameElement = document.createElement('span');
  usernameElement.id = `mention-list-item-id-${userId || ''}`;
  usernameElement.textContent = `${id}`;
  usernameElement.classList.add('ck', 'ck-button__label', 'ck-mention-name');
  itemElement.appendChild(usernameElement);

  const emailElement = document.createElement('span');
  itemElement.classList.add('has-email');
  emailElement.textContent = `${email}`;
  emailElement.classList.add('ck', 'ck-button__label', 'ck-mention-email');
  itemElement.appendChild(emailElement);

  return itemElement;
};
